export const BLOCKCHAIN_COURSES = [
  {
    id: 'blockchain-fundamentals',
    title: 'Blockchain Fundamentals',
    description: 'Master blockchain technology, cryptocurrency basics, and decentralized applications (DApps).',
    level: 'beginner',
    totalDuration: '12-15 hours',
    image: '/api/placeholder/400/300',
    prerequisites: ['Basic programming knowledge', 'Understanding of cryptography basics', 'JavaScript familiarity'],
    learningOutcomes: [
      'Understand blockchain architecture and consensus mechanisms',
      'Build smart contracts with Solidity',
      'Deploy and interact with DApps',
      'Implement cryptocurrency transactions',
      'Design tokenomics and NFT systems',
      'Apply blockchain security best practices'
    ],
    modules: [
      {
        id: 'blockchain-architecture',
        title: 'Blockchain Architecture & Cryptography',
        description: 'Core blockchain concepts, cryptographic principles, and distributed ledger technology',
        duration: '120 minutes',
        difficulty: 'beginner',
        content: 'Blockchain fundamentals and cryptographic foundations...'
      }
    ],
    type: 'blockchain'
  }
];